export enum ProductType {
  STANDARD = "standard",
  PLUS = "plus",
}

export enum ProductInterval {
  QUARTER = "quarter",
  YEAR = "year",
}

export class Product {
  id: ProductType;
  name: string;
  pricePerQuarter: ProductPrice;
  pricePerYear: ProductPrice;

  constructor(
    id: ProductType,
    name: string,
    pricePerQuarter: ProductPrice,
    pricePerYear: ProductPrice,
  ) {
    this.id = id;
    this.name = name;
    this.pricePerQuarter = pricePerQuarter;
    this.pricePerYear = pricePerYear;
  }

  getPrice(interval: ProductInterval) {
    return interval === ProductInterval.QUARTER
      ? this.pricePerQuarter
      : this.pricePerYear;
  }

  getPaymentInformation(users: number, interval: ProductInterval) {
    return this.getPrice(interval).calcAmount(
      Math.min(Math.max(users, 2), 100),
    );
  }
}

export class ProductPrice {
  units: number;
  price: number;

  constructor(units: number, price: number) {
    this.units = units;
    this.price = price;
  }

  calcAmount(users: number) {
    const amountPerMonth =
      Math.round((2 * this.price + 0.75 * this.price * (users - 2)) / 100) *
      100;

    return {
      users: users,
      amountPerMonth: amountPerMonth,
      totalAmount: amountPerMonth * this.units,
      totalAmountTax: amountPerMonth * this.units * 0.23,
      totalAmountWithTax: amountPerMonth * this.units * 1.23,
    };
  }
}

export const standard = new Product(
  ProductType.STANDARD,
  "Standard",
  new ProductPrice(3, 1800),
  new ProductPrice(12, 1200),
);

export const plus = new Product(
  ProductType.PLUS,
  "Plus",
  new ProductPrice(3, 2300),
  new ProductPrice(12, 1700),
);
